(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hc-quantity-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  function clamp(input, raw) {
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var n = parseInt(raw, 10);
    if (isNaN(n)) n = min;
    if (n < min) n = min;
    var max = input.max === '' ? null : parseInt(input.max, 10);
    if (max !== null && !isNaN(max) && n > max) n = max;
    return n;
  }

  function step(wrap, delta) {
    var input = wrap.querySelector('[data-hc-qty-input]');
    if (!input) return;
    var next = clamp(input, (parseInt(input.value, 10) || 0) + delta);
    if (String(next) !== input.value) {
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var dec = e.target.closest('[data-hc-qty-dec]');
    if (dec) {
      var decWrap = dec.closest('[data-hc-qty]');
      if (decWrap) step(decWrap, -1);
      return;
    }
    var inc = e.target.closest('[data-hc-qty-inc]');
    if (inc) {
      var incWrap = inc.closest('[data-hc-qty]');
      if (incWrap) step(incWrap, 1);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-hc-qty-input]')) return;
    var clamped = clamp(input, input.value);
    if (String(clamped) !== input.value) input.value = clamped;
  });
})();
  } catch(e) { console.error(e); }
})();

})();
